import React, { useState } from 'react';
    import { motion, AnimatePresence } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import { useAuth } from '../context/AuthContext';
    import SafeIcon from '../common/SafeIcon';
    import AboutModal from './AboutModal';
    import ServicesModal from './ServicesModal';
    import ContactModal from './ContactModal';
    import { useFeatureFlags } from '../context/FeatureFlagContext';
    import * as FiIcons from 'react-icons/fi';

    const { FiMenu, FiX, FiLogIn, FiUserPlus, FiGrid, FiLogOut } = FiIcons;

    const Header = () => {
        const { user, signOut } = useAuth();
        const { isEnabled } = useFeatureFlags();
        const [showAboutModal, setShowAboutModal] = useState(false);
        const [showServicesModal, setShowServicesModal] = useState(false);
        const [showContactModal, setShowContactModal] = useState(false);
        const [isMenuOpen, setIsMenuOpen] = useState(false);

        const closeAll = () => setIsMenuOpen(false);

        return (
            <>
                <header className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
                    <div className="container mx-auto px-4 py-4">
                        <div className="flex items-center justify-between">
                            <Link to="/" className="flex items-center space-x-3">
                                <img src="https://folder.host/images/2025/11/16/clink-logo.png" alt="Chaldean Link Logo" className="h-8 w-auto" />
                            </Link>
                            <nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-slate-700">
                                {isEnabled('jobs') && <Link to="/jobs" className="hover:text-slate-900 transition-colors">Jobs</Link>}
                                {isEnabled('events') && <Link to="/events" className="hover:text-slate-900 transition-colors">Events</Link>}
                                {isEnabled('deals') && <Link to="/deals" className="hover:text-slate-900 transition-colors">Deals</Link>}
                                <button onClick={() => setShowAboutModal(true)} className="hover:text-slate-900 transition-colors">About</button>
                                <button onClick={() => setShowServicesModal(true)} className="hover:text-slate-900 transition-colors">Services</button>
                                <button onClick={() => setShowContactModal(true)} className="hover:text-slate-900 transition-colors">Contact</button>
                            </nav>
                            <div className="flex items-center space-x-2">
                                {user ? (
                                    <>
                                        <Link to="/dashboard" className="hidden sm:flex items-center space-x-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                            <SafeIcon icon={FiGrid} />
                                            <span>Dashboard</span>
                                        </Link>
                                        <button onClick={signOut} className="hidden sm:flex items-center space-x-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                            <SafeIcon icon={FiLogOut} />
                                            <span>Sign Out</span>
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <Link to="/login" className="hidden sm:flex items-center space-x-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                            <SafeIcon icon={FiLogIn} />
                                            <span>Login</span>
                                        </Link>
                                        <Link to="/signup" className="hidden sm:flex items-center space-x-2 bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-slate-800 transition-colors">
                                            <SafeIcon icon={FiUserPlus} />
                                            <span>Sign Up</span>
                                        </Link>
                                    </>
                                )}
                                <div className="md:hidden">
                                    <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 text-slate-600 hover:text-slate-900">
                                        <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-xl" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <AnimatePresence>
                        {isMenuOpen && (
                            <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: 'auto' }}
                                exit={{ opacity: 0, height: 0 }}
                                className="md:hidden bg-white border-t border-slate-200"
                            >
                                <div className="flex flex-col items-start space-y-2 p-4">
                                    {isEnabled('jobs') && <Link to="/jobs" onClick={closeAll} className="block w-full text-left p-2 rounded-md hover:bg-slate-100">Jobs</Link>}
                                    {isEnabled('events') && <Link to="/events" onClick={closeAll} className="block w-full text-left p-2 rounded-md hover:bg-slate-100">Events</Link>}
                                    {isEnabled('deals') && <Link to="/deals" onClick={closeAll} className="block w-full text-left p-2 rounded-md hover:bg-slate-100">Deals</Link>}
                                    <button onClick={() => { setShowAboutModal(true); closeAll(); }} className="block w-full text-left p-2 rounded-md hover:bg-slate-100">About</button>
                                    <button onClick={() => { setShowServicesModal(true); closeAll(); }} className="block w-full text-left p-2 rounded-md hover:bg-slate-100">Services</button>
                                    <button onClick={() => { setShowContactModal(true); closeAll(); }} className="block w-full text-left p-2 rounded-md hover:bg-slate-100">Contact</button>
                                    <div className="border-t w-full my-2"></div>
                                    {user ? (
                                        <>
                                            <Link to="/dashboard" onClick={closeAll} className="flex items-center space-x-2 w-full text-left p-2 rounded-md hover:bg-slate-100"><SafeIcon icon={FiGrid} /><span>Dashboard</span></Link>
                                            <button onClick={() => { signOut(); closeAll(); }} className="flex items-center space-x-2 w-full text-left p-2 rounded-md hover:bg-slate-100"><SafeIcon icon={FiLogOut} /><span>Sign Out</span></button>
                                        </>
                                    ) : (
                                        <>
                                            <Link to="/login" onClick={closeAll} className="flex items-center space-x-2 w-full text-left p-2 rounded-md hover:bg-slate-100"><SafeIcon icon={FiLogIn} /><span>Login</span></Link>
                                            <Link to="/signup" onClick={closeAll} className="w-full text-center bg-slate-900 text-white px-4 py-2 rounded-lg hover:bg-slate-800">Sign Up</Link>
                                        </>
                                    )}
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </header>
                <AboutModal isOpen={showAboutModal} onClose={() => setShowAboutModal(false)} />
                <ServicesModal isOpen={showServicesModal} onClose={() => setShowServicesModal(false)} />
                <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
            </>
        );
    };

    export default Header;